<template>
  <div>
    <search-table
      ref="searchTable"
      :columnMove="false"
      :columns="syncTableProperties"
      :data="openTableData"
      :need-pagination="false"
      :needAllColumnSummary="true"
      :showSummary="true"
      :tableRowKey="'id'"
      @getTableData="getTableData"
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';

export default {
  components: { SearchTable },
  props: ['tableData'],
  name: 'HandCut',
  data() {
    return {
      syncTableProperties: [
        { label: '员工姓名', prop: 'stff_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { label: '所属打样间', prop: 'dept_name', itemType: 'input', input: false, sortable: false, widthAuto: true },
        {
          label: '刺绣款数',
          prop: 'cutNumberOfModels',
          itemType: 'input',
          input: false,
          sortable: true,
          widthAuto: true
        },
        { label: '手裁用量', prop: 'cutQuantity', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '样品数量', prop: 'numberOfSamples', itemType: 'input', input: false, sortable: true, widthAuto: true }
        // { label: '式样个数', prop: 'sampleNum', itemType: 'input', input: false, sortable: true, widthAuto: true },
        // { label: '式样片数', prop: 'numberOfSamplePieces', itemType: 'input', input: false, sortable: true, widthAuto: true }
      ]
    };
  },
  computed: {
    openTableData() {
      setTimeout(() => {
        this.$refs.searchTable.$refs.multiTable.doLayout();
      }, 0);
      return this.tableData;
    }
  },
  methods: {
    getTableData() {
      this.$emit('getTableData', this.$refs.searchTable.searchForm);
    }
  }
};
</script>

<style scoped></style>
